import BaseService from './BaseService';
import {
  LossesResponse,
  TrendResponse,
  CompetitorsResponse,
  CoverageResponse,
  UploadResponse,
  SerpResponse,
  TransparencyResponse,
  AlertSettings,
} from 'pages/AuctionIntelligence/types';

class AuctionIntelligenceService extends BaseService {
  async getLosses(params: {
    level: 'ad_group' | 'campaign';
    days?: number;
    baselineDays?: number;
    minSpend?: number;
  }): Promise<LossesResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<LossesResponse>(
      () => this.http.get('auction-intelligence/losses', { params }),
      'Failed to fetch /auction-intelligence/losses',
    );
  }

  async getTrend(params: {
    campaignId?: string;
    adGroupId?: string;
    days?: number;
  }): Promise<TrendResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<TrendResponse>(
      () => this.http.get('auction-intelligence/trend', { params }),
      'Failed to fetch /auction-intelligence/trend',
    );
  }

  async getCompetitors(params: {
    campaignId?: string;
    adGroupId?: string;
    weeks?: number;
    accountId?: string;
  }): Promise<CompetitorsResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<CompetitorsResponse>(
      () => this.http.get('auction-intelligence/competitors', { params }),
      'Failed to fetch /auction-intelligence/competitors',
    );
  }

  async getCoverage(): Promise<CoverageResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<CoverageResponse>(
      () => this.http.get('auction-intelligence/coverage'),
      'Failed to fetch /auction-intelligence/coverage',
    );
  }

  async uploadCsv(csv: string, accountId?: string): Promise<UploadResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<UploadResponse>(
      () => this.http.post('auction-intelligence/upload', { csv, accountId }),
      'Failed to upload auction insights CSV',
    );
  }

  async getSerp(keyword: string, store: string): Promise<SerpResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<SerpResponse>(
      () => this.http.get('auction-intelligence/serp', { params: { keyword, store } }),
      'Failed to fetch live SERP',
    );
  }

  async getAlertSettings(): Promise<AlertSettings | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<AlertSettings>(
      () => this.http.get('auction-intelligence/alert-settings'),
      'Failed to fetch alert settings',
    );
  }

  async getTransparency(domain: string): Promise<TransparencyResponse | null> {
    await this._getAccessToken();
    return this.handleHttpRequest<TransparencyResponse>(
      () => this.http.get('auction-intelligence/transparency', { params: { domain } }),
      'Failed to fetch Transparency Center creatives',
    );
  }
}

export default AuctionIntelligenceService;
